import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { SpectrogramMapItem } from '@ledium/types';

import ProjectEditorView from './ProjectEditorView';

const ProjectEditor = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const { mainMenu, onSave } = useLediumPage({
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            recipeId: formData.recipeId,
            spectrogramMap: formData.spectrogramMap,
            startTime: formData.startTime,
            pauseTime: formData.pauseTime,
            running: formData.running || false,
            groupId: formData.groupId
        })
    });

    if (!formData.loaded) {
        return null;
    }

    return <ProjectEditorView onClose={mainMenu} onSave={onSave} spectrogramMap={formData.spectrogramMap as SpectrogramMapItem[]} />;
};

export default ProjectEditor;
